import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  title: ReactNode;
  isArchived?: boolean;
  leftElement?: ReactNode;
  rightElement?: React.ReactNode;
  children?: React.ReactNode;
}

export const DetailItem = ({ leftElement, rightElement, title, isArchived = false, children }: Props) => {
  return (
    <div css={contentItemContainer}>
      <div css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div css={{ display: 'flex', gap: theme.spacing(0.5), alignItems: 'center' }}>
          {leftElement}
          {typeof title === 'string' ? <DetailItemHeader title={title} isArchived={isArchived} /> : title}
        </div>
        {rightElement}
      </div>
      {children}
    </div>
  );
};

const DetailItemHeader = ({ title, isArchived }: { title: string; isArchived?: boolean }) =>
  isArchived ? (
    <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
      <Text size='medium' weight='bold' color={isArchived ? 'subdued' : undefined}>
        {title}
      </Text>
      {isArchived && <Icon name='archive-small' color='subdued' size={12} />}
    </div>
  ) : (
    <Text size='medium' weight='bold'>
      {title}
    </Text>
  );

const contentItemContainer = css({
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  '> :not(:first-child)': {
    marginLeft: theme.spacing(2.5),
  },
});
